import styled from 'styled-components'
import media from '../styles/media'

export const theme = {
  mainColor: 'rgb(187, 227, 232)',
  white: 'rgb(255, 255, 255)',
  black: '#202122',

}

export const Container = styled.div`
& .row {
  margin-right: 0;
  margin-left: 0;
}
  color: ${theme.white};
  ${media.md`
    padding: 20px 0;
  `};
  
  & img {
    width: 70%;
    display: block;
    margin: 0 auto;
  }
  &.title {
    & p {
      text-align: center;
      text-transform: uppercase;
      font-size: 20px;
      font-size: 23px;
      padding-left: 20px;
      padding-right: 20px;
      color: ${theme.lightBlack};
      font-weight: 200;
      letter-spacing: -0px;
      padding-top: 40px;
      & button {
        color: ${theme.blue};
        text-decoration: underline;
        background: none;
        border: none;
      }
    }
  }

  &.content {
    margin-top: 10px;
    padding: 20px;
    letter-spacing: -1px;

    p {
      font-size: 18px;
      line-height: 1;
      color: ${theme.grey};
      span {
        color: ${theme.blue};
      }
    }

    & table {
      color: #fff;
      border: 1px solid #909192;
      background: linear-gradient( 
        135deg, #3d3f41 0%, #3d3f41 17%, #434546 17%, #434546 40%, #4a4b4c 40%, #4a4b4c 40%, #4a4b4c 99% );
      & thead {
        height: 40px;
        padding-left: 20px;
        color: #fff;
        letter-spacing: 0;
        border: 1px solid #909192;
        display: flex;
        justify-content: center;
        align-items: center;
      }

      & tbody {
        & .cabecera {
          background-color: transparent;
          color: #fff;
          height: 40px;
        }

        & .odd {
          background: transparent;
        }

        & tr {
          & td {
            border-bottom: 1px solid #f1f1ec;
            padding: 5px 20px;
}
          }
        }
      }
    }

    & .important-text {
      border: solid 4px #e7e7e8;
      font-size: 20px;
      line-height: 1;
      color: #0069aa;
      margin: 0 auto;
      padding: 15px 20px;
      text-align: center;
    }

    & .links {
      text-align: center;
      margin-top: 20px;
    }
  }

  ${media.sm`
    &.title{
      & p{
        padding: 10px 0;
        font-size: 16px;
      }
    }

    &.content{
      padding: 5px;
      & .col-md-12{
        padding: 0;
      }
    }
  `};
`



// WEBPACK FOOTER //
// ./src/styles/theme.js